// translations/invoiceConversion.ts
export const translations = {
    en: {
      'converter.buttons.usesCredit': '(Uses 1 credit)',
      'converter.buttons.startNew': 'Start New',
      'converter.pdfToXml.title': 'PDF to XRechnung Converter',
      'converter.pdfToXml.subtitle': 'Convert your PDF invoices to structured XML/XRechnung format in seconds',
      'converter.pdfToCii.title': 'PDF to XRechnung (CII) Converter',
      'converter.pdfToCii.subtitle': 'Convert your PDF invoices to XRechnung in CII (Cross Industry Invoice) format',
      'converter.pdfToCii.description': 'Convert PDF invoices to CII format, the alternative XRechnung standard preferred by many German accounting systems.',
      'converter.pdfToUbl.title': 'PDF to XRechnung (UBL) Converter',
      'converter.pdfToUbl.subtitle': 'Convert your PDF invoices to XRechnung in UBL (Universal Business Language) format',
      'converter.converter': 'Converter',
      'converter.xmlToPdf.subtitle': 'Convert your XML/XRechnung files to PDF format in seconds',
      'converter.dropzone.title': 'Drag & drop your invoice here',
      'converter.dropzone.dragActive': 'Drop the file here',
      'converter.dropzone.browse': 'or click to browse',
      'converter.dropzone.supportedPdf': 'Supported format: PDF (max 10MB)',
      'converter.dropzone.supportedXml': 'Supported format: XML (max 10MB)',
      'converter.dropzone.noFile': 'No file chosen',
      'converter.dropzone.clickToReplace': 'Click or drag to replace',
      'converter.steps.uploadPdf': 'Upload PDF',
      'converter.steps.uploadXml': 'Upload XML',
      'converter.steps.viewData': 'Review Data',
      'converter.steps.downloadXml': 'Download XRechnung',
      'converter.steps.downloadPdf': 'Download PDF',
      'converter.buttons.back': 'Back',
      'converter.buttons.next': 'Next',
      'converter.buttons.convertAnother': 'Convert Another File',
      'converter.errors.selectXml': 'Please select an XML file.',
      'converter.errors.pdfGeneration': 'PDF generation failed. Please try again.',
      'converter.buttons.downloadPdf': 'Download PDF',
      'converter.buttons.downloadXml': 'Download XRechnung',
      'converter.buttons.downloadCii': 'Download CII XML',
      'converter.buttons.downloadAll': 'Download All as ZIP',
      'converter.buttons.usesCredits': '(Uses {count} credits)',
      'converter.batch.progress': 'Processed',
      'converter.fileStatus.waiting': 'Waiting',
      'converter.fileStatus.processing': 'Processing',
      'converter.fileStatus.processed_ready_for_download': 'Ready',
      'converter.fileStatus.downloaded': 'Downloaded',
      'converter.fileStatus.error': 'Error',
      'converter.fileList.title': 'File Progress',
      'converter.currentCredits': 'Current Credits: {count}',
      'converter.downloadDisclaimer': "By downloading, you confirm you've reviewed all data for accuracy, acknowledge AI may make mistakes, and accept full responsibility.",
      'converter.xmlContent': 'XML Content',
      'converter.parsedData': 'Parsed Data',

      // EAS Code Selector
      'easSelector.schemeType': 'Address Type:',
      'easSelector.format': 'Format:',
      'easSelector.example': 'Example:',
      'easSelector.suggestionTitle': 'Suggested Address Type',
      'easSelector.suggestionText': 'Based on the format, this looks like a {{type}} ({{confidence}}% confidence)',
      'easSelector.applySuggestion': 'Apply Suggestion',
      'easSelector.validationError': 'Please enter a valid {{type}}',

      'upload.steps': [
        'Upload & Extract',
        'Confirm & Edit',
        'Download XRechnung'
      ],
      'upload.dropzone.title': 'Drag & drop your invoice here',
      'upload.dropzone.dragActive': 'Drop the PDF here',
      'upload.dropzone.browse': 'or click to browse',
      'upload.dropzone.supportedFormatsPDF': 'Supported format: PDF (max 10MB)',
      'upload.dropzone.supportedFormatsXML': 'Supported format: XML (max 10MB)',
      'upload.dropzone.clickToReplace': 'Click or drag to replace',
      'upload.review.title': 'Review & Edit Invoice Data',
      'upload.review.checkCarefully': 'All fields are editable - please check carefully!',
      'upload.review.noData': 'No data available. Please upload an invoice first.',
      'upload.xml.title': 'Generated XRechnung',
      'upload.buttons.back': 'Back',
      'upload.buttons.next': 'Next',
      'upload.buttons.downloadXml': 'Download XRechnung',
      'upload.buttons.uploadPdf': 'Upload PDF',
      'upload.buttons.checkData': 'Check Data',
      'upload.loading.processing': 'Processing your invoice...',
      'upload.loading.extracting': 'Extracting invoice data...',
      'upload.loading.analyzing': 'Analyzing document structure...',
      'upload.loading.mapping': 'Mapping to XRechnung XML format...',
      'upload.loading.schema': 'Applying XRechnung schema...',
      'upload.loading.validating': 'Validating output...',
      'upload.errors.noFile': 'Please select a PDF file.',
      'upload.errors.uploadFailed': 'Failed to upload and process the file.',
      'upload.errors.xmlFailed': 'Failed to generate XML.',
      'upload.errors.safariNetworkIssue': 'Safari network issue detected. Try keeping this tab active or switch to Chrome/Firefox for better performance.',
      'upload.errors.safariTimeout': 'Safari timeout detected. Please refresh the page and try again, or consider using Chrome/Firefox.',
      'upload.validation.missingFields': 'Some recommended fields are empty. You can still proceed, but filling them might be required for government exchange.',
      'upload.validation.generateXml': 'Generate XML',

      // Processing status messages
      'converter.processing.pending': 'Processing queued...',
      'converter.processing.analyzing': 'Analyzing invoice...',
      'converter.processing.completed': 'Processing completed!',
      'converter.processing.failed': 'Processing failed',
      'converter.processing.unknown': 'Processing...',
      
      // Multi-file processing
      'converter.multiFile.title': 'Processing {count} files',
      'converter.multiFile.uploadStatus': '{completed} of {total} files uploaded',
      'converter.multiFile.processingStatus': '{completed} of {total} files processed',
      'converter.multiFile.downloadAll': 'Download All ({count} files)',
      'converter.multiFile.selectAll': 'Select All',
      'converter.multiFile.deselectAll': 'Deselect All',
      'converter.multiFile.selectedCount': '{count} files selected',
      'converter.multiFile.removeFile': 'Remove file',
      'converter.multiFile.retryFailed': 'Retry Failed Files',
      
      // Validation messages
      'converter.validation.checking': 'Checking compliance...',
      'converter.validation.passed': 'Validation passed',
      'converter.validation.failed': 'Validation failed',
      'converter.validation.warnings': '{count} warnings found',
      'converter.validation.errors': '{count} errors found',
      'converter.validation.preflightCheck': 'Pre-flight compliance check',
      'converter.validation.preflightPassed': 'Pre-flight check passed',
      'converter.validation.preflightFailed': 'Pre-flight check failed',
      'converter.validation.cannotProceed': 'Cannot proceed: {{errorCount}} validation errors found. Please fix all required fields before generating XML.',
      'converter.validation.allowInvalid': 'Generate invalid XRechnung anyway',
      'converter.validation.allowInvalidWarning': 'Warning: This will create a non-compliant XRechnung that may be rejected by recipients. Use only for testing purposes.',
      'converter.validation.allValid': 'All fields are valid',
      'converter.validation.issues': 'Validation Issues',
      'converter.validation.validating': 'Validating...',
      'converter.validation.warningTitle': 'Validation Errors Found',
      'converter.validation.warningMessage': 'The invoice contains validation errors. The generated XML may not be compliant with XRechnung standards.',
      'converter.validation.errorSummary': '{{errorCount}} errors, {{warningCount}} warnings',
      'converter.validation.continueWarning': 'Continuing with errors may result in validators rejecting your invoice.',
      'converter.validation.acceptRiskLabel': 'I understand that there are potential validation errors in the invoice and that it may not be accepted by certain systems or validation tools. I want to continue anyway.',
      'converter.validation.viewErrors': 'View errors',
      'converter.buttons.goBack': 'Go Back and Fix',
      'converter.buttons.goBackAndFix': 'Go Back and Fix Errors',
      'converter.buttons.continueAnyway': 'Continue and Accept Risk',
      'converter.validation.criticalErrorsTitle': 'Critical Validation Errors',
      'converter.validation.criticalErrorsMessage': 'The invoice contains critical errors that must be fixed for XRechnung/ZUGFeRD compliance.',
      'converter.validation.criticalErrorsExplanation': 'Critical fields like seller VAT ID, electronic address, and payment terms are required by German e-invoicing standards.',
      
      // Enhanced error messages
      'converter.errors.uploadTimeout': 'Upload timed out. Please check your connection and try again.',
      'converter.errors.processingTimeout': 'Processing timed out. The file might be too complex.',
      'converter.errors.invalidFormat': 'Invalid file format. Please ensure the file is not corrupted.',
      'converter.errors.serverError': 'Server error occurred. Please try again later.',
      'converter.errors.networkError': 'Network error. Please check your internet connection.',
      'converter.errors.sessionExpired': 'Session expired. Please refresh the page and try again.',
      'converter.errors.downloadFailed': 'Download failed. Please try again.',
      'errors.noBatchId': 'No batch ID available. Please restart the process.',
      'errors.batchDownloadFailed': 'Failed to download batch files. Please try again.',
      'converter.errors.retryMessage': 'Click to retry this file',
      
      // Help tooltips
      'converter.help.dragDrop': 'You can drag and drop multiple files at once',
      'converter.help.supportedFormats': 'We support PDF invoices in all common formats',
      'converter.help.processing': 'Processing typically takes 10-30 seconds per file',
      'converter.help.validation': 'We validate against official XRechnung standards',
      'converter.help.download': 'Downloads include both XML and embedded PDF formats',

      // New invoice fields translations (English)
      invoiceFields: {
        ID: {
          label: 'Invoice Number',
          description: 'Unique identifier for this invoice'
        },
        IssueDate: {
          label: 'Issue Date',
          description: 'Date when the invoice was issued'
        },
        DueDate: {
          label: 'Due Date',
          description: 'Date by which the payment should be made'
        },
        InvoiceTypeCode: {
          label: 'Invoice Type',
          description: 'Type of invoice (e.g., "380" for standard invoice)',
          selectPlaceholder: '--- Select Invoice Type ---'
        },
        DocumentCurrencyCode: {
          label: 'Currency',
          description: 'Main currency used (e.g., "EUR")'
        },
        OrderReference: {
          label: 'Order Reference',
          description: 'Buyer\'s purchase order number'
        },
        ContractReference: {
          label: 'Contract Reference',
          description: 'Contract reference number'
        },
        BuyerReference: {
          label: 'Buyer Reference',
          description: 'Buyer\'s internal reference number'
        },
        ActualDeliveryDate: {
          label: 'Delivery Date',
          description: 'Date when goods or services were delivered'
        },
        Seller: {
          LegalName: {
            label: 'Legal Name',
            description: 'Official registered name of the selling company'
          },
          CompanyID: {
            label: 'VAT Identifier',
            description: 'VAT registration number of the seller'
          },
          CompanyLegalForm: {
            label: 'Company Legal Form',
            description: 'Legal form of the selling company'
          },
          Street: {
            label: 'Street',
            description: 'Street address of the seller'
          },
          City: {
            label: 'City',
            description: 'City of the seller'
          },
          PostalCode: {
            label: 'Postal Code',
            description: 'Postal code of the seller'
          },
          CountryCode: {
            label: 'Country Code',
            description: 'Two-letter country code of the seller'
          },
          EndpointID: {
            label: 'Electronic address',
            description: 'Identifies the Seller\'s electronic address to which the application level response to the invoice may be delivered.'
          },
          SchemeID: {
            label: 'Address Type',
            description: 'Electronic address scheme identifier (e.g., EM for email, 0204 for Leitweg-ID)',
            selectPlaceholder: 'Select electronic address scheme...'
          },
          Email: {
            label: 'Email',
            description: 'Contact email address of the seller'
          },
          ContactName: {
            label: 'Contact Name',
            description: 'Name of the contact person at the selling company'
          },
          Phone: {
            label: 'Phone',
            description: 'Contact phone number of the seller'
          },
          SupplierNumber: {
            label: 'Supplier Number',
            description: 'Internal supplier identification number'
          },
          TaxNumber: {
            label: 'Tax Number',
            description: 'Local tax registration number (Steuernummer)'
          },
          VATId: {
            label: 'VAT ID',
            description: 'VAT identification number'
          }
        },
        Buyer: {
          LegalName: {
            label: 'Legal Name',
            description: 'Official registered name of the buying company'
          },
          Street: {
            label: 'Street',
            description: 'Street address of the buyer'
          },
          City: {
            label: 'City',
            description: 'City of the buyer'
          },
          PostalCode: {
            label: 'Postal Code',
            description: 'Postal code of the buyer'
          },
          CountryCode: {
            label: 'Country Code',
            description: 'Two-letter country code of the buyer'
          },
          EndpointID: {
            label: 'Electronic address',
            description: 'Identifies the Buyer\'s electronic address to which the application level response to the invoice may be delivered.'
          },
          SchemeID: {
            label: 'Address Type',
            description: 'Electronic address scheme identifier (e.g., EM for email, 0204 for Leitweg-ID)',
            selectPlaceholder: 'Select electronic address scheme...'
          },
          ContactName: {
            label: 'Contact Name',
            description: 'Name of the contact person at the buying company'
          }
        },
        Payment: {
          IBAN: {
            label: 'IBAN',
            description: 'International Bank Account Number for payment (e.g., IBAN)'
          },
          BIC: {
            label: 'BIC',
            description: 'Bank Identifier Code'
          },
          Type: {
            label: 'Type',
            description: 'Type of payment'
          },
          Terms: {
            label: 'Terms',
            description: 'Payment terms description (e.g., "Net within 30 days")'
          },
          InstructionNote: {
            label: 'Payment Instructions',
            description: 'Instructions for payment processing (required for XRechnung compliance)'
          }
        },
        Tax: {
          Amount: {
            label: 'Tax Amount',
            description: 'Total VAT amount'
          },
          BaseAmount: {
            label: 'Base Amount',
            description: 'Amount on which VAT is calculated'
          },
          TaxSubamount: {
            label: 'Tax Subamount',
            description: 'Tax amount for this category'
          },
          Category: {
            label: 'VAT Category',
            description: 'Category of VAT applied'
          },
          Percent: {
            label: 'VAT Rate (%)',
            description: 'Percentage rate of VAT applied'
          },
          Scheme: {
            label: 'Tax Scheme',
            description: 'Type of tax scheme'
          }
        },
        Total: {
          NetAmount: {
            label: 'Net Amount',
            description: 'Sum of all line items before tax'
          },
          TaxExclusiveAmount: {
            label: 'Amount excl. VAT',
            description: 'Total amount without VAT'
          },
          TaxInclusiveAmount: {
            label: 'Amount incl. VAT',
            description: 'Total amount with VAT'
          },
          PayableAmount: {
            label: 'Payable Amount',
            description: 'Final amount due for payment'
          }
        },
        ProfileID: {
          label: 'Profile ID',
          description: 'Business process type identifier'
        },
        CustomizationID: {
          label: 'Customization ID',
          description: 'Technical specification version identifier'
        },
        Notes: {
          Note: {
            label: 'Note',
            description: 'Any general notes about the invoice'
          }
        },
        InvoiceLine: {
          ID: {
            label: 'Line Item ID',
            description: 'Unique identifier for this line item'
          },
          Name: {
            label: 'Item Name',
            description: 'Name of the item'
          },
          Description: {
            label: 'Item Description',
            description: 'Detailed description of the item'
          },
          SellersItemIdentification: {
            label: 'Article Number',
            description: 'Seller\'s article or SKU number for this item'
          },
          Note: {
            label: 'Note',
            description: 'Any general notes about the invoice line'
          },
          Quantity: {
            label: 'Quantity',
            description: 'Number of items'
          },
          UnitPrice: {
            label: 'Unit Price',
            description: 'Price per unit'
          },
          NetAmount: {
            label: 'Net Amount',
            description: 'Sum of all line items before tax'
          },
          VATRate: {
            label: 'VAT Rate',
            description: 'Percentage rate of VAT applied'
          },
          TaxCategory: {
            label: 'Tax Category',
            description: 'VAT category applied to this line item',
            selectPlaceholder: 'Select tax category...'
          },
          UnitCode: {
            label: 'Unit Code',
            description: 'Unit of measurement for the quantity',
            selectPlaceholder: 'Select unit...'
          }
        }
      },
      'invoice.table.description': 'Description',
      'invoice.table.quantity': 'Quantity',
      'invoice.table.unitPrice': 'Unit Price',
      'invoice.table.netAmount': 'Net Amount',
      'invoice.buttons.addLine': 'Add Invoice Line',
      'invoice.buttons.deleteLine': 'Delete Line',
      'invoice.validation.fieldRequired': 'This field is required',
      'invoice.validation.invalidFormat': 'Invalid format',
      'invoice.validation.invalidDate': 'Invalid date format',
      'invoice.validation.invalidEmail': 'Invalid email address',
      'invoice.validation.invalidIBAN': 'Invalid IBAN format',
      'invoice.validation.invalidBIC': 'Invalid BIC format',
      'invoice.validation.invalidCountryCode': 'Invalid country code',
      'invoice.validation.invalidCurrency': 'Invalid currency code',
      'invoice.validation.invalidAmount': 'Invalid amount',
      'invoice.validation.amountMismatch': 'Amount does not match calculated total',
      
      // Validation messages from invoiceValidation.ts
      'validation.invoiceNumberRequired': 'Invoice number is required',
      'validation.issueDateRequired': 'Issue date is required',
      'validation.invalidDateFormat': 'Invalid date format. Use YYYY-MM-DD',
      'validation.issueDateFuture': 'Issue date cannot be in the future',
      'validation.invoiceTypeRequired': 'Invoice type code is required',
      'validation.currencyCodeRequired': 'Currency code is required',
      'validation.dueDateBeforeIssue': 'Due date cannot be before issue date',
      'validation.sellerNameRequired': 'Seller name is required',
      'validation.sellerAddressRequired': 'Seller address is required',
      'validation.sellerCountryRequired': 'Seller country is required',
      'validation.buyerNameRequired': 'Buyer name is required',
      'validation.buyerElectronicAddressRequired': 'Buyer electronic address must be provided (PEPPOL-EN16931-R010)',
      'validation.buyerCountryRequired': 'Buyer country is required',
      'validation.taxCategoryRequired': 'Tax category is required',
      'validation.taxPercentRequired': 'Tax percentage is required for standard rate',
      'validation.taxPercentRange': 'Tax percentage must be between 0 and 100',
      'validation.sellerTelephoneRequired': 'Seller contact telephone number is required (BR-DE-6)',
      'validation.sellerEmailRequired': 'Seller contact email address is required (BR-DE-7)',
      'validation.sellerContactRequired': 'Seller contact point is required (BR-DE-5)',
      'validation.paymentInstructionsRequired': 'Payment instructions are required for XRechnung compliance (BR-DE-1)',
      'validation.sellerCityRequired': 'Seller city is required (BR-DE-3)',
      'validation.sellerPostalCodeRequired': 'Seller postal code is required (BR-DE-4)',
      'validation.buyerCityRequired': 'Buyer city is required (BR-DE-8)',
      'validation.buyerPostalCodeRequired': 'Buyer postal code is required (BR-DE-9)',
      'validation.emailFormatInvalid': 'Email should contain exactly one @ symbol with valid format (BR-DE-28)',
      'validation.telephoneFormatInvalid': 'Telephone number should contain at least 3 digits (BR-DE-27)',
      'invoice.expandRow': 'Expand row',
      'invoice.collapseRow': 'Collapse row',
      'invoice.lineItems.expanded': 'Showing details for line {id}',
      'invoice.lineItems.collapsed': 'Details hidden for line {id}',

      'sections.invoiceInformation': 'Invoice Information',
      'sections.seller': 'Seller',
      'sections.buyer': 'Buyer',
      'sections.delivery': 'Delivery',
      'sections.payment': 'Payment',
      'sections.tax': 'Tax',
      'sections.total': 'Total',
      'sections.lineItems': 'Line Items',
      'sections.notes': 'Notes',
      'sections.other': 'Other',

      // Tax Subtotals
      'invoiceFields.taxSubtotals.noSubtotals': 'No tax subtotals found',
      'invoiceFields.taxSubtotals.breakdown': 'Tax Breakdown',
      'invoiceFields.taxSubtotals.multipleRates': '{count} different tax rates',
      'invoiceFields.taxSubtotals.category': 'Tax Category',
      'invoiceFields.taxSubtotals.rate': 'Tax Rate',
      'invoiceFields.taxSubtotals.taxableAmount': 'Taxable Amount',
      'invoiceFields.taxSubtotals.taxAmount': 'Tax Amount',
      'invoiceFields.taxSubtotals.totalTaxableAmount': 'Total Taxable Amount',
      'invoiceFields.taxSubtotals.totalTaxAmount': 'Total Tax Amount',
      'invoiceFields.taxSubtotals.selectCategory': 'Select tax category...',
      'invoiceFields.taxSubtotals.exemptionRequired': 'This tax category requires an exemption reason',
      'invoiceFields.TaxSubtotals.label': 'Tax Breakdown',
      'invoiceFields.TaxSubtotals.description': 'Detailed breakdown of taxes by category and rate',
      'invoiceFields.taxSubtotals.categoryDescription': 'Category of VAT applied (Standard, Reduced, Zero-rated, etc.)',
      'invoiceFields.taxSubtotals.rateDescription': 'Percentage rate of VAT for this category',
      'invoiceFields.taxSubtotals.taxableAmountDescription': 'Net amount subject to this tax rate',
      'invoiceFields.taxSubtotals.taxAmountDescription': 'Tax amount calculated for this category',
      'invoiceFields.taxSubtotals.addSubtotal': 'Add Tax Subtotal',
      'invoiceFields.taxSubtotals.deleteSubtotal': 'Delete Tax Subtotal',
      'invoiceFields.taxSubtotals.validationError': 'Tax subtotals ({calculated}) do not match total tax amount ({expected})',

      'xml.title': 'Generated XRechnung',
      'xml.cii.title': 'Generated CII XML',
      'xml.copy': 'Copy',
      'xml.copied': 'Copied',
      'xml.download': 'Download XRechnung',
      'xml.preview': 'XRechnung Preview',

      'xrechnungViewer.title': 'Free XRechnung & XML Viewer',
      'xrechnungViewer.subtitle': 'View and validate your XRechnung and XML files instantly - No registration required',
      'xrechnungViewer.description': 'Upload your XRechnung or XML file with one click to view its contents in a beautiful, structured format. Free to use, no registration needed.',
      'xrechnungViewer.uploadButton': 'Upload XRechnung or XML File',
      'xrechnungViewer.headline': 'XRechnung & XML Viewer',
      'xrechnungViewer.steps.upload': 'Upload XML',
      'xrechnungViewer.steps.viewData': 'View & Validate',
      'xrechnungViewer.xmlContent': 'XML Content',
      'xrechnungViewer.parsedData': 'Parsed Invoice Data',

      // Multi-file processing message
      'converter.processing.multipleFiles': 'Processing files...',

      // File navigation in multi-file review
      'converter.fileNavigation.viewing': 'Viewing',
      'converter.fileNavigation.of': 'of',
      'converter.fileNavigation.previous': 'Previous',
      'converter.fileNavigation.next': 'Next',
      // Invoice Status Bubbles Tooltips
      'bubbles.statusPrefix': 'Status: ',
      'bubbles.currentSuffix': ' (Current)',
      'bubbles.status.not_started': 'Not Started',
      'bubbles.status.processing': 'Processing',
      'bubbles.status.processed_ready_for_download': 'Processed (Ready for Download)',
      'bubbles.status.downloaded': 'Downloaded',
      'bubbles.status.error': 'Error',
      invoiceTypes: {
        '325': '325 - Proforma Invoice',
        '326': '326 - Partial Invoice',
        '380': '380 - Invoice',
        '381': '381 - Credit Note',
        '383': '383 - Debit Note',
        '384': '384 - Corrected Invoice',
        '386': '386 - Prepayment Invoice',
        '387': '387 - Rental Invoice',
        '388': '388 - Tax Invoice',
        '389': '389 - Self-billed Invoice',
        '393': '393 - Factoring Invoice',
        '394': '394 - Lease Invoice',
        '575': '575 - Insurer Invoice',
        '623': '623 - Forwarder Invoice',
        '780': '780 - Freight Invoice',
        '875': '875 - Partial Invoice for Construction Services',
        '876': '876 - Final Partial Invoice for Construction Services',
        '877': '877 - Final Invoice for Construction Services',
        '935': '935 - Customs Invoice'
      },
      
      // Validation translations
      'validation.title': 'Validation Results',
      'validation.inProgress': 'Validating invoice data...',
      'validation.errors': 'Errors',
      'validation.warnings': 'Warnings',
      'validation.info': 'Info',
      'validation.field': 'Field',
      'validation.noErrors': 'All fields validated successfully',
      'validation.allValid': 'All fields are valid',
      'validation.issues': 'Validation Issues',
      'validation.validating': 'Validating...',
      'validation.notices': 'Notices',
      'validation.checkingFields': 'Checking invoice fields...',
      'validation.validationComplete': 'Validation complete',
      
      // ZUGFeRD specific
      'zugferd.title': 'ZUGFeRD PDF',
      'zugferd.ready': 'Your ZUGFeRD PDF is ready',
      'zugferd.description': 'The PDF contains embedded invoice data in XML format',
      'zugferd.displayOptions': 'Display Options',
      'zugferd.pdfView.title': 'ZUGFeRD PDF View',
      'zugferd.pdfView.description': 'Shows the complete ZUGFeRD PDF with embedded invoice data. This is the final file you\'ll send to recipients.',
      'zugferd.xmlView.title': 'XRechnung XML View',
      'zugferd.xmlView.description': 'Shows the structured XML data embedded within the ZUGFeRD PDF. This contains the machine-readable invoice information.',
      'zugferd.xmlView.noContent': 'No XML content available. Please ensure this is a valid ZUGFeRD document.',
      'converter.pdfToZugferd.title': 'PDF to ZUGFeRD Converter',
      'converter.pdfToZugferd.subtitle': 'Convert your PDF invoices to ZUGFeRD format with embedded XML data',
      'converter.zugferd.ready': 'Your ZUGFeRD Invoice is Ready!',
      'converter.zugferd.readyDescription': 'Your PDF has been successfully converted to ZUGFeRD format with embedded CII XML data. This hybrid format is compatible with both human readers and automated systems.',
      'converter.zugferd.xmlComponent': 'CII XML Component',
      'converter.zugferd.xrechnungComponent': 'XRechnung Component',
      'converter.zugferd.pdfComponent': 'PDF Component',
      'converter.buttons.downloadZugferd': 'Download ZUGFeRD PDF',
      'converter.steps.downloadZugferd': 'Download ZUGFeRD',
      'converter.errors.generationFailed': 'Failed to generate ZUGFeRD. Please try again.',
      'converter.errors.missingData': 'Missing required data. Please ensure all steps are completed.',
      'converter.errors.maxFilesExceeded': 'You can upload up to 10 files only.',
      'converter.errors.allFilesFailed': 'All files failed to process. Please try again.',
      'converter.errors.selectFile': 'Please select a file.',
      'converter.errors.processingFailed': 'Processing failed. Please try again.',
      'converter.errors.selectXmlFile': 'Please select an XML file.',
      'converter.errors.xmlParseFailed': 'Failed to parse the XML file. Please ensure it is a valid XRechnung or XML invoice.',
      'xml.formatSelection.title': 'Output Format Selection',
      'xml.formatSelection.ublDescription': 'UBL format is widely supported and compatible with most e-invoicing systems.',
      'xml.formatSelection.ciiDescription': 'CII format is used for XRechnung and ZUGFeRD compliance in Germany.',
      
      // Conversion tools grid
      'convert.pdfToCii': 'PDF to XRechnung (CII)',
      'convert.pdfToXRechnungUse': 'Required for German public sector invoicing and B2B transactions with government entities',
      'convert.pdfToCiiUse': 'Alternative XRechnung format preferred by some German companies and accounting systems',
      'convert.pdfToZugferdUse': 'Hybrid format combining PDF and XML data, widely used in German B2B commerce',
      'convert.xrechnungToPdfUse': 'Create human-readable PDF versions for printing, archiving, and manual review',
      'convert.xrechnungViewerUse': 'Validate compliance and review XRechnung content without conversion',
      'convert.toolsTitle': 'Choose Your Conversion Tool',
      'convert.toolsDescription': 'Select the perfect tool for your invoice conversion needs. Each tool is optimized for specific document types and use cases.',
      
      // Convert page
      'convert.title': 'Convert Your Invoices',
      'convert.description': 'Transform your business documents with our comprehensive suite of e-invoice conversion tools',
      'convert.subtitle': 'Transform your business documents with our comprehensive suite of e-invoice conversion tools. Fast, secure, and compliant with all European standards.',
      'convert.whyChooseTitle': 'Why Choose Our Platform?',
      'convert.benefit1': 'Lightning Fast',
      'convert.benefit1Desc': 'Process your documents in seconds with our optimized conversion engine',
      'convert.benefit2': 'Secure & Private',
      'convert.benefit2Desc': 'Your documents are processed securely and never stored on our servers',
      'convert.benefit3': 'Standards Compliant',
      'convert.benefit3Desc': 'Full compliance with German and European e-invoicing standards',
      
    },
    de: {
      'converter.buttons.usesCredit': '(Verwendet 1 Credit)',
      'converter.buttons.startNew': 'Neu beginnen',
      'converter.pdfToXml.title': 'PDF zu XRechnung Konverter',
      'converter.pdfToXml.subtitle': 'Konvertieren Sie Ihre PDF-Rechnungen in Sekunden in strukturiertes XML/XRechnung-Format',
      'converter.pdfToCii.title': 'PDF zu XRechnung (CII) Konverter',
      'converter.pdfToCii.subtitle': 'Konvertieren Sie Ihre PDF-Rechnungen zu XRechnung im CII (Cross Industry Invoice) Format',
      'converter.pdfToCii.description': 'Konvertieren Sie PDF-Rechnungen in das CII-Format, den alternativen XRechnung-Standard, der von vielen deutschen Buchhaltungssystemen bevorzugt wird.',
      'converter.pdfToUbl.title': 'PDF zu XRechnung (UBL) Konverter',
      'converter.pdfToUbl.subtitle': 'Konvertieren Sie Ihre PDF-Rechnungen zu XRechnung im UBL (Universal Business Language) Format',
      'converter.converter': 'Konverter',
      'converter.xmlToPdf.subtitle': 'Konvertieren Sie Ihre XML/XRechnung-Dateien in Sekunden in PDF-Format',
      'converter.dropzone.title': 'Rechnung hier ablegen',
      'converter.dropzone.dragActive': 'Datei hier ablegen',
      'converter.dropzone.browse': 'oder zum Durchsuchen klicken',
      'converter.dropzone.supportedPdf': 'Unterstütztes Format: PDF (max 10MB)',
      'converter.dropzone.supportedXml': 'Unterstütztes Format: XML (max 10MB)',
      'converter.dropzone.noFile': 'Keine Datei ausgewählt',
      'converter.dropzone.clickToReplace': 'Klicken oder ziehen zum Ersetzen',
      'converter.steps.uploadPdf': 'PDF hochladen',
      'converter.steps.uploadXml': 'XML hochladen',
      'converter.steps.viewData': 'Daten prüfen',
      'converter.steps.downloadXml': 'XML herunterladen',
      'converter.steps.downloadPdf': 'PDF herunterladen',
      'converter.buttons.back': 'Zurück',
      'converter.buttons.next': 'Weiter',
      'converter.buttons.convertAnother': 'Weitere Datei konvertieren',
      'converter.errors.selectXml': 'Bitte wählen Sie eine XML-Datei aus.',
      'converter.errors.pdfGeneration': 'PDF-Generierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
      'converter.buttons.downloadPdf': 'PDF herunterladen',
      'converter.buttons.downloadXml': 'XRechnung herunterladen',
      'converter.buttons.downloadCii': 'CII XML herunterladen',
      'converter.buttons.downloadAll': 'Alle als ZIP herunterladen',
      'converter.buttons.usesCredits': '(Verwendet {count} Credits)',
      'converter.batch.progress': 'Verarbeitet',
      'converter.fileStatus.waiting': 'Wartet',
      'converter.fileStatus.processing': 'Verarbeitung',
      'converter.fileStatus.processed_ready_for_download': 'Bereit',
      'converter.fileStatus.downloaded': 'Heruntergeladen',
      'converter.fileStatus.error': 'Fehler',
      'converter.fileList.title': 'Dateifortschritt',
      'converter.errors.downloadFailed': 'Download fehlgeschlagen. Bitte versuchen Sie es erneut.',
      'errors.noBatchId': 'Keine Batch-ID verfügbar. Bitte starten Sie den Vorgang neu.',
      'errors.batchDownloadFailed': 'Batch-Download fehlgeschlagen. Bitte versuchen Sie es erneut.',
      'converter.currentCredits': 'Aktuelles Guthaben: {count}',
      'converter.downloadDisclaimer': 'Mit dem Download bestätigen Sie, dass Sie alle Daten auf Richtigkeit geprüft haben. Sie erkennen an, dass KI-Inhalte Fehler enthalten können, und übernehmen dafür die volle Verantwortung.',
      'converter.xmlContent': 'XML Inhalt',
      'converter.parsedData': 'Geparste Daten',

      // EAS Code Selector
      'easSelector.schemeType': 'Adresstyp:',
      'easSelector.format': 'Format:',
      'easSelector.example': 'Beispiel:',
      'easSelector.suggestionTitle': 'Vorgeschlagener Adresstyp',
      'easSelector.suggestionText': 'Basierend auf dem Format sieht dies wie {{type}} aus ({{confidence}}% Sicherheit)',
      'easSelector.applySuggestion': 'Vorschlag übernehmen',
      'easSelector.validationError': 'Bitte geben Sie eine gültige {{type}} ein',

      'upload.steps': [
        'Hochladen & Extrahieren',
        'Prüfen & Bearbeiten',
        'XML herunterladen'
      ],
      'upload.dropzone.title': 'Rechnung hier ablegen',
      'upload.dropzone.dragActive': 'PDF hier ablegen',
      'upload.dropzone.browse': 'oder zum Durchsuchen klicken',
      'upload.dropzone.supportedFormatsPDF': 'Unterstütztes Format: PDF (max 10MB)',
      'upload.dropzone.supportedFormatsXML': 'Unterstütztes Format: XML (max 10MB)',
      'upload.dropzone.clickToReplace': 'Klicken oder ziehen zum Ersetzen',
      'upload.review.title': 'Rechnungsdaten prüfen & bearbeiten',
      'upload.review.checkCarefully': 'Alle Felder sind editierbar - bitte sorgfältig prüfen!',
      'upload.review.noData': 'Keine Daten verfügbar. Bitte laden Sie zuerst eine Rechnung hoch.',
      'upload.xml.title': 'Generierte XML',
      'upload.buttons.back': 'Zurück',
      'upload.buttons.next': 'Weiter',
      'upload.buttons.downloadXml': 'XML herunterladen',
      'upload.buttons.uploadPdf': 'PDF hochladen',
      'upload.buttons.checkData': 'Daten prüfen',
      'upload.loading.processing': 'Ihre Rechnung wird verarbeitet...',
      'upload.loading.extracting': 'Rechnungsdaten werden extrahiert...',
      'upload.loading.analyzing': 'Dokumentstruktur wird analysiert...',
      'upload.loading.mapping': 'Mapping zum XRechnung XML-Format...',
      'upload.loading.schema': 'XRechnung-Schema wird angewendet...',
      'upload.loading.validating': 'Ausgabe wird validiert...',
      'upload.errors.noFile': 'Bitte wählen Sie eine PDF-Datei aus.',
      'upload.errors.uploadFailed': 'Fehler beim Hochladen und Verarbeiten der Datei.',
      'upload.errors.xmlFailed': 'Fehler beim Generieren der XML.',
      'upload.errors.safariNetworkIssue': 'Safari-Netzwerkproblem erkannt. Versuchen Sie, diesen Tab aktiv zu halten, oder wechseln Sie zu Chrome/Firefox für bessere Performance.',
      'upload.errors.safariTimeout': 'Safari-Timeout erkannt. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut, oder verwenden Sie Chrome/Firefox.',
      'upload.validation.missingFields': 'Einige empfohlene Felder sind leer. Sie können trotzdem fortfahren, aber das Ausfüllen könnte für den behördlichen Austausch erforderlich sein.',
      'upload.validation.generateXml': 'XML generieren',

      // Processing status messages (German)
      'converter.processing.pending': 'Verarbeitung in Warteschlange...',
      'converter.processing.analyzing': 'Rechnung wird analysiert...',
      'converter.processing.completed': 'Verarbeitung abgeschlossen!',
      'converter.processing.failed': 'Verarbeitung fehlgeschlagen',
      'converter.processing.unknown': 'Verarbeitung läuft...',
      
      // Multi-file processing (German)
      'converter.multiFile.title': 'Verarbeitung von {count} Dateien',
      'converter.multiFile.uploadStatus': '{completed} von {total} Dateien hochgeladen',
      'converter.multiFile.processingStatus': '{completed} von {total} Dateien verarbeitet',
      'converter.multiFile.downloadAll': 'Alle herunterladen ({count} Dateien)',
      'converter.multiFile.selectAll': 'Alle auswählen',
      'converter.multiFile.deselectAll': 'Alle abwählen',
      'converter.multiFile.selectedCount': '{count} Dateien ausgewählt',
      'converter.multiFile.removeFile': 'Datei entfernen',
      'converter.multiFile.retryFailed': 'Fehlgeschlagene Dateien wiederholen',
      
      // Validation messages (German)
      'converter.validation.checking': 'Compliance wird überprüft...',
      'converter.validation.passed': 'Validierung erfolgreich',
      'converter.validation.failed': 'Validierung fehlgeschlagen',
      'converter.validation.warnings': '{count} Warnungen gefunden',
      'converter.validation.errors': '{count} Fehler gefunden',
      'converter.validation.preflightCheck': 'Vorab-Compliance-Prüfung',
      'converter.validation.preflightPassed': 'Vorabprüfung erfolgreich',
      'converter.validation.preflightFailed': 'Vorabprüfung fehlgeschlagen',
      'converter.validation.cannotProceed': 'Fortfahren nicht möglich: {{errorCount}} Validierungsfehler gefunden. Bitte beheben Sie alle erforderlichen Felder vor der XML-Generierung.',
      'converter.validation.allowInvalid': 'Ungültige XRechnung trotzdem generieren',
      'converter.validation.allowInvalidWarning': 'Warnung: Dies erstellt eine nicht-konforme XRechnung, die von Empfängern abgelehnt werden kann. Nur für Testzwecke verwenden.',
      'converter.validation.allValid': 'Alle Felder sind gültig',
      'converter.validation.issues': 'Validierungsprobleme',
      'converter.validation.validating': 'Validiere...',
      'converter.validation.warningTitle': 'Validierungsfehler gefunden',
      'converter.validation.warningMessage': 'Die Rechnung enthält Validierungsfehler. Die generierte XML-Datei entspricht möglicherweise nicht den XRechnung-Standards.',
      'converter.validation.errorSummary': '{{errorCount}} Fehler, {{warningCount}} Warnungen',
      'converter.validation.continueWarning': 'Das Fortfahren mit Fehlern kann dazu führen, dass Validatoren Ihre Rechnung ablehnen.',
      'converter.validation.acceptRiskLabel': 'Die Rechnung enthält potentielle Validierungsfehler und kann von manchen Systemen und Validierungstools nicht akzeptiert werden. Ich möchte trotzdem fortfahren.',
      'converter.validation.viewErrors': 'Fehler anzeigen',
      'converter.buttons.goBack': 'Zurück und korrigieren',
      'converter.buttons.goBackAndFix': 'Zurück und Fehler beheben',
      'converter.buttons.continueAnyway': 'Fortfahren und Risiko akzeptieren',
      'converter.validation.criticalErrorsTitle': 'Kritische Validierungsfehler',
      'converter.validation.criticalErrorsMessage': 'Die Rechnung enthält kritische Fehler, die für die XRechnung/ZUGFeRD-Konformität behoben werden müssen.',
      'converter.validation.criticalErrorsExplanation': 'Kritische Felder wie USt-IdNr. des Verkäufers, elektronische Adresse und Zahlungsbedingungen sind für deutsche E-Rechnungsstandards erforderlich.',
      
      // Enhanced error messages (German)
      'converter.errors.uploadTimeout': 'Upload-Zeitüberschreitung. Bitte überprüfen Sie Ihre Verbindung und versuchen Sie es erneut.',
      'converter.errors.processingTimeout': 'Verarbeitungs-Zeitüberschreitung. Die Datei könnte zu komplex sein.',
      'converter.errors.invalidFormat': 'Ungültiges Dateiformat. Bitte stellen Sie sicher, dass die Datei nicht beschädigt ist.',
      'converter.errors.serverError': 'Serverfehler aufgetreten. Bitte versuchen Sie es später erneut.',
      'converter.errors.networkError': 'Netzwerkfehler. Bitte überprüfen Sie Ihre Internetverbindung.',
      'converter.errors.sessionExpired': 'Sitzung abgelaufen. Bitte aktualisieren Sie die Seite und versuchen Sie es erneut.',
      'converter.errors.retryMessage': 'Klicken Sie, um diese Datei erneut zu versuchen',
      
      // Help tooltips (German)
      'converter.help.dragDrop': 'Sie können mehrere Dateien gleichzeitig per Drag & Drop ablegen',
      'converter.help.supportedFormats': 'Wir unterstützen PDF-Rechnungen in allen gängigen Formaten',
      'converter.help.processing': 'Die Verarbeitung dauert normalerweise 10-30 Sekunden pro Datei',
      'converter.help.validation': 'Wir validieren gegen offizielle XRechnung-Standards',
      'converter.help.download': 'Downloads enthalten sowohl XML- als auch eingebettete PDF-Formate',

      // New invoice fields translations (German)
      invoiceFields: {
        ID: {
          label: 'Rechnungsnummer',
          description: 'Eindeutige Kennung für diese Rechnung'
        },
        IssueDate: {
          label: 'Ausstellungsdatum',
          description: 'Datum, an dem die Rechnung ausgestellt wurde'
        },
        DueDate: {
          label: 'Fälligkeitsdatum',
          description: 'Datum, bis zu dem die Zahlung erfolgen sollte'
        },
        InvoiceTypeCode: {
          label: 'Rechnungstyp',
          description: 'Code zur Angabe des Rechnungstyps (z.B. 380 für Handelsrechnung)',
          selectPlaceholder: '--- Rechnungstyp auswählen ---'
        },
        DocumentCurrencyCode: {
          label: 'Währung',
          description: 'Verwendete Hauptwährung (z.B. "EUR")'
        },
        OrderReference: {
          label: 'Bestellreferenz',
          description: 'Einkaufsbestellnummer des Käufers'
        },
        ContractReference: {
          label: 'Vertragsreferenz',
          description: 'Vertragsnummer'
        },
        BuyerReference: {
          label: 'Käuferreferenz (Leitweg-ID)',
          description: 'Interne Referenznummer (Leitweg‑ID) des Käufers'
        },
        ActualDeliveryDate: {
          label: 'Lieferdatum',
          description: 'Datum, an dem Waren oder Dienstleistungen geliefert wurden'
        },
        Seller: {
          LegalName: {
            label: 'Juristischer Name',
            description: 'Offiziell eingetragener Name des Verkäufers'
          },
          CompanyID: {
            label: 'Umsatzsteuer-Identifikationsnummer',
            description: 'Umsatzsteuer-Registrierungsnummer des Verkäufers'
          },
          CompanyLegalForm: {
            label: 'Rechtsform des Unternehmens',
            description: 'Rechtsform des verkaufenden Unternehmens'
          },
          Street: {
            label: 'Straße',
            description: 'Straßenadresse des Verkäufers'
          },
          City: {
            label: 'Stadt',
            description: 'Stadt des Verkäufers'
          },
          PostalCode: {
            label: 'Postleitzahl',
            description: 'Postleitzahl des Verkäufers'
          },
          CountryCode: {
            label: 'Ländercode',
            description: 'Zweibuchstabiger Ländercode des Verkäufers'
          },
          EndpointID: {
            label: 'Elektronische Adresse',
            description: 'Identifiziert die elektronische Adresse des Verkäufers, an die die Applikationsantwort auf die Rechnung gesendet werden kann.'
          },
          SchemeID: {
            label: 'Adresstyp',
            description: 'Elektronisches Adressschema-Kennzeichen (z.B. EM für E-Mail, 0204 für Leitweg-ID)',
            selectPlaceholder: 'Elektronisches Adressschema auswählen...'
          },
          Email: {
            label: 'E-Mail',
            description: 'Kontakt-E-Mail-Adresse des Verkäufers'
          },
          ContactName: {
            label: 'Name des Ansprechpartners',
            description: 'Name der Kontaktperson beim Verkäufer'
          },
          Phone: {
            label: 'Telefon',
            description: 'Telefonnummer des Verkäufers'
          },
          SupplierNumber: {
            label: 'Lieferantennummer',
            description: 'Interne Lieferantenidentifikationsnummer'
          },
          TaxNumber: {
            label: 'Steuernummer',
            description: 'Lokale Steuerregistrierungsnummer'
          },
          VATId: {
            label: 'USt-IdNr.',
            description: 'Umsatzsteuer-Identifikationsnummer'
          }
        },
        Buyer: {
          LegalName: {
            label: 'Juristischer Name',
            description: 'Offiziell eingetragener Name des Käufers'
          },
          Street: {
            label: 'Straße',
            description: 'Straßenadresse des Käufers'
          },
          City: {
            label: 'Stadt',
            description: 'Stadt des Käufers'
          },
          PostalCode: {
            label: 'Postleitzahl',
            description: 'Postleitzahl des Käufers'
          },
          CountryCode: {
            label: 'Ländercode',
            description: 'Zweibuchstabiger Ländercode des Käufers'
          },
          EndpointID: {
            label: 'Elektronische Adresse',
            description: 'Identifiziert die elektronische Adresse des Käufers, an die die Applikationsantwort auf die Rechnung gesendet werden kann.'
          },
          SchemeID: {
            label: 'Adresstyp',
            description: 'Elektronisches Adressschema-Kennzeichen (z.B. EM für E-Mail, 0204 für Leitweg-ID)',
            selectPlaceholder: 'Elektronisches Adressschema auswählen...'
          },
          ContactName: {
            label: 'Kontaktname',
            description: 'Name der Kontaktperson beim Käuferunternehmen'
          }
        },
        Payment: {
          IBAN: {
            label: 'IBAN',
            description: 'Internationale Bankkontonummer für Zahlungen (z.B. IBAN)'
          },
          BIC: {
            label: 'BIC',
            description: 'Bank-Identifikationscode'
          },
          Type: {
            label: 'Art',
            description: 'Art der Zahlung'
          },
          Terms: {
            label: 'Zahlungsbedingungen',
            description: 'Beschreibung der Zahlungsbedingungen (z.B. "Netto innerhalb von 30 Tagen")'
          },
          InstructionNote: {
            label: 'Zahlungsanweisungen',
            description: 'Anweisungen für die Zahlungsabwicklung (erforderlich für XRechnung-Konformität)'
          }
        },
        Tax: {
          Amount: {
            label: 'Steuerbetrag',
            description: 'Gesamte Umsatzsteuer'
          },
          BaseAmount: {
            label: 'Bemessungsgrundlage',
            description: 'Betrag, auf den die Umsatzsteuer berechnet wird'
          },
          TaxSubamount: {
            label: 'Steuerteilbetrag',
            description: 'Steuerbetrag für diese Kategorie'
          },
          Category: {
            label: 'USt-Kategorie',
            description: 'Angewandte Umsatzsteuer-Kategorie'
          },
          Percent: {
            label: 'USt-Satz (%)',
            description: 'Prozentualer Umsatzsteuersatz'
          },
          Scheme: {
            label: 'Steuersystem',
            description: 'Art des Steuersystems'
          }
        },
        Total: {
          NetAmount: {
            label: 'Nettobetrag',
            description: 'Summe aller Posten vor Steuern'
          },
          TaxExclusiveAmount: {
            label: 'Betrag exkl. USt',
            description: 'Gesamtbetrag ohne Umsatzsteuer'
          },
          TaxInclusiveAmount: {
            label: 'Betrag inkl. USt',
            description: 'Gesamtbetrag mit Umsatzsteuer'
          },
          PayableAmount: {
            label: 'Zahlbarer Betrag',
            description: 'Endbetrag zur Zahlung'
          }
        },
        ProfileID: {
          label: 'Profil-ID',
          description: 'Geschäftsprozess-Typkennzeichen'
        },
        CustomizationID: {
          label: 'Anpassungs-ID',
          description: 'Kennzeichnung der technischen Spezifikationsversion'
        },
        Notes: {
          Note: {
            label: 'Notiz',
            description: 'Beliebige allgemeine Anmerkungen zur Rechnung'
          }
        },
        InvoiceLine: {
          ID: {
            label: 'Positionsnummer',
            description: 'Eindeutige Kennung für diese Position'
          },
          Name: {
            label: 'Artikelname',
            description: 'Name des Artikels'
          },
          Description: {
            label: 'Artikelbeschreibung',
            description: 'Detaillierte Beschreibung des Artikels'
          },
          SellersItemIdentification: {
            label: 'Artikelnummer',
            description: 'Artikelnummer oder SKU des Verkäufers für diesen Artikel'
          },
          Note: {
            label: 'Notiz',
            description: 'Beliebige allgemeine Anmerkungen zur Rechnung'
          },
          Quantity: {
            label: 'Menge',
            description: 'Anzahl der Artikel'
          },
          UnitPrice: {
            label: 'Einzelpreis',
            description: 'Preis pro Einheit'
          },
          NetAmount: {
            label: 'Nettobetrag',
            description: 'Summe aller Posten vor Steuern'
          },
          VATRate: {
            label: 'Umsatzsteuersatz',
            description: 'Prozentualer Umsatzsteuersatz'
          },
          TaxCategory: {
            label: 'Steuerkategorie',
            description: 'MwSt-Kategorie für diese Position',
            selectPlaceholder: 'Steuerkategorie auswählen...'
          },
          UnitCode: {
            label: 'Maßeinheit',
            description: 'Maßeinheit für die Menge',
            selectPlaceholder: 'Einheit auswählen...'
          }
        }
      },
      'invoice.table.description': 'Beschreibung',
      'invoice.table.quantity': 'Menge',
      'invoice.table.unitPrice': 'Einzelpreis',
      'invoice.table.netAmount': 'Nettobetrag',
      'invoice.buttons.addLine': 'Rechnungsposition hinzufügen',
      'invoice.buttons.deleteLine': 'Position löschen',
      'invoice.validation.fieldRequired': 'Dieses Feld ist erforderlich',
      'invoice.validation.invalidFormat': 'Ungültiges Format',
      'invoice.validation.invalidDate': 'Ungültiges Datumsformat',
      'invoice.validation.invalidEmail': 'Ungültige E-Mail-Adresse',
      'invoice.validation.invalidIBAN': 'Ungültiges IBAN-Format',
      'invoice.validation.invalidBIC': 'Ungültiges BIC-Format',
      'invoice.validation.invalidCountryCode': 'Ungültiger Ländercode',
      'invoice.validation.invalidCurrency': 'Ungültiger Währungscode',
      'invoice.validation.invalidAmount': 'Ungültiger Betrag',
      'invoice.validation.amountMismatch': 'Betrag stimmt nicht mit der berechneten Summe überein',
      
      // Validation messages from invoiceValidation.ts
      'validation.invoiceNumberRequired': 'Rechnungsnummer ist erforderlich',
      'validation.issueDateRequired': 'Rechnungsdatum ist erforderlich',
      'validation.invalidDateFormat': 'Ungültiges Datumsformat. Verwenden Sie JJJJ-MM-TT',
      'validation.issueDateFuture': 'Rechnungsdatum kann nicht in der Zukunft liegen',
      'validation.invoiceTypeRequired': 'Rechnungstyp ist erforderlich',
      'validation.currencyCodeRequired': 'Währungscode ist erforderlich',
      'validation.dueDateBeforeIssue': 'Fälligkeitsdatum kann nicht vor dem Rechnungsdatum liegen',
      'validation.sellerNameRequired': 'Verkäufername ist erforderlich',
      'validation.sellerAddressRequired': 'Verkäuferadresse ist erforderlich',
      'validation.sellerCountryRequired': 'Verkäuferland ist erforderlich',
      'validation.buyerNameRequired': 'Käufername ist erforderlich',
      'validation.buyerElectronicAddressRequired': 'Die elektronische Adresse des Käufers muss angegeben werden (PEPPOL-EN16931-R010)',
      'validation.buyerCountryRequired': 'Käuferland ist erforderlich',
      'validation.taxCategoryRequired': 'Steuerkategorie ist erforderlich',
      'validation.taxPercentRequired': 'Steuersatz ist für Standardsteuersatz erforderlich',
      'validation.taxPercentRange': 'Steuersatz muss zwischen 0 und 100 liegen',
      'validation.sellerTelephoneRequired': 'Telefonnummer des Verkäuferkontakts ist erforderlich (BR-DE-6)',
      'validation.sellerEmailRequired': 'E-Mail-Adresse des Verkäuferkontakts ist erforderlich (BR-DE-7)',
      'validation.sellerContactRequired': 'Verkäuferkontaktpunkt ist erforderlich (BR-DE-5)',
      'validation.paymentInstructionsRequired': 'Zahlungsanweisungen sind für XRechnung-Compliance erforderlich (BR-DE-1)',
      'validation.sellerCityRequired': 'Verkäuferstadt ist erforderlich (BR-DE-3)',
      'validation.sellerPostalCodeRequired': 'Verkäuferpostleitzahl ist erforderlich (BR-DE-4)',
      'validation.buyerCityRequired': 'Käuferstadt ist erforderlich (BR-DE-8)',
      'validation.buyerPostalCodeRequired': 'Käuferpostleitzahl ist erforderlich (BR-DE-9)',
      'validation.emailFormatInvalid': 'E-Mail sollte genau ein @-Symbol mit gültigem Format enthalten (BR-DE-28)',
      'validation.telephoneFormatInvalid': 'Telefonnummer sollte mindestens 3 Ziffern enthalten (BR-DE-27)',
      'invoice.expandRow': 'Zeile erweitern',
      'invoice.collapseRow': 'Zeile einklappen',
      'invoice.lineItems.expanded': 'Details für Position {id} werden angezeigt',
      'invoice.lineItems.collapsed': 'Details für Position {id} ausgeblendet',

      'sections.invoiceInformation': 'Rechnungsinformationen',
      'sections.seller': 'Verkäufer',
      'sections.buyer': 'Käufer',
      'sections.delivery': 'Lieferung',
      'sections.payment': 'Zahlung',
      'sections.tax': 'Steuern',
      'sections.total': 'Gesamt',
      'sections.lineItems': 'Rechnungspositionen',
      'sections.notes': 'Anmerkungen',
      'sections.other': 'Andere',

      // Tax Subtotals
      'invoiceFields.taxSubtotals.noSubtotals': 'Keine Steueraufschlüsselung gefunden',
      'invoiceFields.taxSubtotals.breakdown': 'Steueraufschlüsselung',
      'invoiceFields.taxSubtotals.multipleRates': '{count} verschiedene Steuersätze',
      'invoiceFields.taxSubtotals.category': 'Steuerkategorie',
      'invoiceFields.taxSubtotals.rate': 'Steuersatz',
      'invoiceFields.taxSubtotals.taxableAmount': 'Bemessungsgrundlage',
      'invoiceFields.taxSubtotals.taxAmount': 'Steuerbetrag',
      'invoiceFields.taxSubtotals.totalTaxableAmount': 'Gesamte Bemessungsgrundlage',
      'invoiceFields.taxSubtotals.totalTaxAmount': 'Gesamtsteuerbetrag',
      'invoiceFields.taxSubtotals.selectCategory': 'Steuerkategorie auswählen...',
      'invoiceFields.taxSubtotals.exemptionRequired': 'Diese Steuerkategorie erfordert einen Befreiungsgrund',
      'invoiceFields.TaxSubtotals.label': 'Steueraufschlüsselung',
      'invoiceFields.TaxSubtotals.description': 'Detaillierte Aufschlüsselung der Steuern nach Kategorie und Satz',
      'invoiceFields.taxSubtotals.categoryDescription': 'Angewandte MwSt-Kategorie (Standard, Ermäßigt, Nullsatz, etc.)',
      'invoiceFields.taxSubtotals.rateDescription': 'Prozentsatz der MwSt für diese Kategorie',
      'invoiceFields.taxSubtotals.taxableAmountDescription': 'Nettobetrag, der diesem Steuersatz unterliegt',
      'invoiceFields.taxSubtotals.taxAmountDescription': 'Berechneter Steuerbetrag für diese Kategorie',
      'invoiceFields.taxSubtotals.addSubtotal': 'Steueraufschlüsselung hinzufügen',
      'invoiceFields.taxSubtotals.deleteSubtotal': 'Steueraufschlüsselung löschen',
      'invoiceFields.taxSubtotals.validationError': 'Steueraufschlüsselungen stimmen nicht mit dem Gesamtsteuerbetrag überein',

      'xml.title': 'Generierte XRechnung',
      'xml.cii.title': 'Generiertes CII XML',
      'xml.copy': 'Kopieren',
      'xml.copied': 'Kopiert',
      'xml.download': 'XRechnung herunterladen',
      'xml.preview': 'XRechnung-Vorschau',

      'xrechnungViewer.title': 'Kostenloser XRechnung & XML Viewer',
      'xrechnungViewer.subtitle': 'Betrachten und validieren Sie Ihre XRechnung und XML-Dateien sofort - Keine Registrierung erforderlich',
      'xrechnungViewer.description': 'XRechnung oder XML-Datei hochladen und Inhalt strukturiert anzeigen. Kostenlos nutzbar, keine Registrierung erforderlich.',
      'xrechnungViewer.uploadButton': 'XRechnung oder XML-Datei hochladen',
      'xrechnungViewer.headline': 'XRechnung & XML Viewer',
      'xrechnungViewer.steps.upload': 'XML Hochladen',
      'xrechnungViewer.steps.viewData': 'Anzeigen & Validieren',
      'xrechnungViewer.xmlContent': 'XML-Inhalt',
      'xrechnungViewer.parsedData': 'Verarbeitete Rechnungsdaten',

      // Mehrfachverarbeitung
      'converter.processing.multipleFiles': '{count} Dateien werden verarbeitet...',

      // Dateinavigation in der Mehrfachprüfung
      'converter.fileNavigation.viewing': 'Anzeigen',
      'converter.fileNavigation.of': 'von',
      'converter.fileNavigation.previous': 'Zurück',
      'converter.fileNavigation.next': 'Weiter',
      // Invoice Status Bubbles Tooltips
      'bubbles.statusPrefix': 'Status: ', // Or 'Zustand: '
      'bubbles.currentSuffix': ' (Aktuell)',
      'bubbles.status.not_started': 'Nicht begonnen',
      'bubbles.status.processing': 'In Bearbeitung',
      'bubbles.status.processed_ready_for_download': 'Verarbeitet (Bereit zum Download)',
      'bubbles.status.downloaded': 'Heruntergeladen',
      'bubbles.status.error': 'Fehler',
      invoiceTypes: {
        '325': '325 - Proformarechnung',
        '326': '326 - Teilrechnung',
        '380': '380 - Rechnung',
        '381': '381 - Gutschriftanzeige',
        '383': '383 - Belastungsanzeige',
        '384': '384 - Rechnungskorrektur',
        '386': '386 - Vorauszahlungsrechnung',
        '387': '387 - Mietrechnung',
        '388': '388 - Steuerrechnung',
        '389': '389 - Selbstfakturierte Rechnung',
        '393': '393 - Inkasso-Rechnung',
        '394': '394 - Leasing-Rechnung',
        '575': '575 - Rechnung des Versicherers',
        '623': '623 - Speditionsrechnung',
        '780': '780 - Frachtrechnung',
        '875': '875 - Teilrechnung für Bauleistungen',
        '876': '876 - Teilschlussrechnung für Bauleistungen',
        '877': '877 - Schlussrechnung für Bauleistungen',
        '935': '935 - Zollrechnung'
      },
      
      // Validation translations
      'validation.title': 'Validierungsergebnisse',
      'validation.inProgress': 'Rechnungsdaten werden validiert...',
      'validation.errors': 'Fehler',
      'validation.warnings': 'Warnungen',
      'validation.info': 'Info',
      'validation.field': 'Feld',
      'validation.noErrors': 'Alle Felder erfolgreich validiert',
      'validation.allValid': 'Alle Felder sind gültig',
      'validation.issues': 'Validierungsprobleme',
      'validation.validating': 'Validiere...',
      'validation.notices': 'Hinweise',
      'validation.checkingFields': 'Rechnungsfelder werden überprüft...',
      'validation.validationComplete': 'Validierung abgeschlossen',
      
      // ZUGFeRD specific
      'zugferd.title': 'ZUGFeRD PDF',
      'zugferd.ready': 'Ihre ZUGFeRD PDF ist bereit',
      'zugferd.description': 'Die PDF enthält eingebettete Rechnungsdaten im XML-Format',
      'zugferd.displayOptions': 'Anzeigeoptionen',
      'zugferd.pdfView.title': 'ZUGFeRD PDF-Ansicht',
      'zugferd.pdfView.description': 'Zeigt die komplette ZUGFeRD-PDF mit eingebetteten Rechnungsdaten. Dies ist die finale Datei, die Sie an Empfänger senden.',
      'zugferd.xmlView.title': 'XRechnung XML-Ansicht',
      'zugferd.xmlView.description': 'Zeigt die strukturierten XML-Daten, die in der ZUGFeRD-PDF eingebettet sind. Diese enthalten die maschinenlesbaren Rechnungsinformationen.',
      'zugferd.xmlView.noContent': 'Kein XML-Inhalt verfügbar. Bitte stellen Sie sicher, dass dies ein gültiges ZUGFeRD-Dokument ist.',
      'converter.pdfToZugferd.title': 'PDF zu ZUGFeRD Konverter',
      'converter.pdfToZugferd.subtitle': 'Konvertieren Sie Ihre PDF-Rechnungen in das ZUGFeRD-Format mit eingebetteten XML-Daten',
      'converter.zugferd.ready': 'Ihre ZUGFeRD-Rechnung ist fertig!',
      'converter.zugferd.readyDescription': 'Ihre PDF wurde erfolgreich in das ZUGFeRD-Format mit eingebetteten CII-XML-Daten konvertiert. Dieses Hybridformat ist sowohl für Menschen als auch für automatisierte Systeme lesbar.',
      'converter.zugferd.xmlComponent': 'CII XML-Komponente',
      'converter.zugferd.xrechnungComponent': 'XRechnung-Komponente',
      'converter.zugferd.pdfComponent': 'PDF-Komponente',
      'converter.buttons.downloadZugferd': 'ZUGFeRD PDF herunterladen',
      'converter.steps.downloadZugferd': 'ZUGFeRD herunterladen',
      'converter.errors.generationFailed': 'ZUGFeRD-Generierung fehlgeschlagen. Bitte versuchen Sie es erneut.',
      'converter.errors.missingData': 'Fehlende erforderliche Daten. Bitte stellen Sie sicher, dass alle Schritte abgeschlossen sind.',
      'converter.errors.maxFilesExceeded': 'Sie können maximal 10 Dateien hochladen.',
      'converter.errors.allFilesFailed': 'Alle Dateien konnten nicht verarbeitet werden. Bitte versuchen Sie es erneut.',
      'converter.errors.selectFile': 'Bitte wählen Sie eine Datei aus.',
      'converter.errors.processingFailed': 'Verarbeitung fehlgeschlagen. Bitte versuchen Sie es erneut.',
      'converter.errors.selectXmlFile': 'Bitte wählen Sie eine XML-Datei aus.',
      'converter.errors.xmlParseFailed': 'Fehler beim Parsen der XML-Datei. Bitte stellen Sie sicher, dass es sich um eine gültige XRechnung oder XML-Rechnung handelt.',
      'xml.formatSelection.title': 'Ausgabeformat-Auswahl',
      'xml.formatSelection.ublDescription': 'UBL-Format ist weit verbreitet und kompatibel mit den meisten E-Rechnungssystemen.',
      'xml.formatSelection.ciiDescription': 'CII-Format wird für XRechnung- und ZUGFeRD-Compliance in Deutschland verwendet.',
      
      // Conversion tools grid
      'convert.pdfToCii': 'PDF zu XRechnung (CII)',
      'convert.pdfToXRechnungUse': 'Erforderlich für deutsche öffentliche Rechnungsstellung und B2B-Transaktionen mit Regierungsstellen',
      'convert.pdfToCiiUse': 'Alternatives XRechnung-Format, das von einigen deutschen Unternehmen und Buchhaltungssystemen bevorzugt wird',
      'convert.pdfToZugferdUse': 'Hybridformat, das PDF- und XML-Daten kombiniert, weit verbreitet im deutschen B2B-Handel',
      'convert.xrechnungToPdfUse': 'Erstellen Sie lesbare PDF-Versionen zum Drucken, Archivieren und zur manuellen Überprüfung',
      'convert.xrechnungViewerUse': 'Validieren Sie die Compliance und überprüfen Sie XRechnung-Inhalte ohne Konvertierung',
      'convert.toolsTitle': 'Wählen Sie Ihr Konvertierungstool',
      'convert.toolsDescription': 'Wählen Sie das perfekte Tool für Ihre Rechnungskonvertierung. Jedes Tool ist für spezifische Dokumenttypen und Anwendungsfälle optimiert.',
      
      // Convert page
      'convert.title': 'Rechnungen konvertieren',
      'convert.description': 'Transformieren Sie Ihre Geschäftsdokumente mit unserer umfassenden Suite von E-Rechnungs-Konvertierungstools',
      'convert.subtitle': 'Transformieren Sie Ihre Geschäftsdokumente mit unserer umfassenden Suite von E-Rechnungs-Konvertierungstools. Schnell, sicher und konform mit allen europäischen Standards.',
      'convert.whyChooseTitle': 'Warum unsere Plattform wählen?',
      'convert.benefit1': 'Blitzschnell',
      'convert.benefit1Desc': 'Verarbeiten Sie Ihre Dokumente in Sekunden mit unserer optimierten Konvertierungs-Engine',
      'convert.benefit2': 'Sicher & Privat',
      'convert.benefit2Desc': 'Ihre Dokumente werden sicher verarbeitet und niemals auf unseren Servern gespeichert',
      'convert.benefit3': 'Standards-konform',
      'convert.benefit3Desc': 'Volle Konformität mit deutschen und europäischen E-Rechnungsstandards',
      
    }
  };
